import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, mobileOrderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/pVbQKvZYaS1qn21uZQpQ/locations/2x91KAu5UwkcYXNkRn2J`}
            >
              <CFView hover>
                <CFImage
                  src={mobileOrderPickupButton}
                  w="100%"
                  maxWidth="250px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/pVbQKvZYaS1qn21uZQpQ/locations/2x91KAu5UwkcYXNkRn2J`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="235px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
